// ats : team, info, faqs
const ats = {
    info: {
        name: 'ATS Auto Detail & Sales',
        address1: '6265 E. 88th Ave. Unit A',
        address2: 'Henderson, CO 80640',
        tel: '720-323-6159', //SIDNEY: 720-323-6159 // JOSE: 303-434-1082
        email: 'contact@atsautosales.co',
        },
    nav: {
        links: [
        { name: 'Home', href: '/' },
        { name: 'Inventory', href: '/inventory' },
        { name: 'Get Financed', href: '/get-financed' },
        { name: 'About Us', href: '/about' },
        { name: 'Contact Us', href: '/contact' },
    ],
        sublinks: [
        { name: 'Auto Detailing', href: '/detailing' },
        { name: 'FAQ', href: '/faq' },
        { name: 'Privacy Policy', href: '/policy' },
    ],
        services: [
        { name: 'Auto Sales', href: '/inventory' },
        { name: 'Auto Detailing', href: '/detailing' },
    ],

        company: [
        { name: 'About Us', href: '/about' },
        { name: 'Contact Us', href: '/contact' },
        { name: 'FAQ', href: '/faq' },
    ],
        legal: [
        { name: 'Privacy Policy', href: '/policy' },
        { name: 'Cookies', href: '/policy' },
    ],
    },
    team: [
    {
      name: 'Guoldy Hurtado',
      role: 'Owner',
      role2: 'General Manager',
      imageUrl:
        'https://ats.limestripes.com/wp-content/uploads/2025/03/profile_gh.webp',
    },
    {
      name: 'Sidney Gray',
      role: 'Owner',
      role2: 'General Manager',
      imageUrl:
        'https://ats.limestripes.com/wp-content/uploads/2025/03/profile_sig.webp',
    },
    {
        name: 'Gary Pacheco',
        role: 'Business Development',
        role2: 'Sales Associate',
        imageUrl:
          'https://ats.limestripes.com/wp-content/uploads/2025/03/profile_gp.webp',
    },
    {
        name: 'Sean Gray',
        role: 'Sales Associate',
        imageUrl:
          'https://ats.limestripes.com/wp-content/uploads/2025/03/profile_seg.webp',
    },
    {
      name: 'Jose Regalet',
      role: 'Inventory Manager',
      imageUrl:
        'https://ats.limestripes.com/wp-content/uploads/2025/03/profile_jer.webp',
    },
    {
        name: 'Jose Canales',
        role: 'Sales Associate',
        imageUrl:
          'https://ats.limestripes.com/wp-content/uploads/2025/03/ats_profile_generic-300x300.jpg',
    },
    {
        name: 'Cassandra Canales',
        role: 'Sales Associate',
        imageUrl:
          'https://ats.limestripes.com/wp-content/uploads/2025/03/ats_profile_generic-300x300.jpg',
    },
    {
        name: 'Jason Martinez',
        role: 'Administrative Assistant',
        role2: 'Auto Detailer',
        imageUrl:
          'https://ats.limestripes.com/wp-content/uploads/2025/03/profile_jm.webp',
    }
    ],
  faqs : [
    {
      id: 1,
      question: "Do you finance? Are you Buy Here Pay Here?",
      answer:
        "No. We don’t offer any in-house financing on any of our vehicles. However, many of our customers acquire their own financing through their bank or credit union and we are happy to provide any information or documents necessary to help with that process.",
    },
    {
        id: 2,
        question: "Is the price listed a down payment?",
        answer:
          "No. The price listed is the cash price of the vehicle excluding tax, tag, title, and dealer fees.",
    },
    {
        id: 3,
        question: "What do I need to buy a car?",
        answer:
          "The requirements to purchase a car from us are that you must be at least 18 years old, have the hard copy of a valid state issued ID, an auto insurance policy in your name, and the full payment amount.",
    },
    {
        id: 4,
        question: "What methods of payment do you accept?",
        answer:
          "Cash, debit/credit card, or Cashiers Check from your bank. There is a 3% fee for credit card purchases.",
    },
    {
        id: 5,
        question: "Do you offer any warranty?",
        answer:
          "No, all of our cars are sold as-is, but you are welcome to test drive the vehicle and have it inspected by your mechanic prior to purchasing.",
    },
    {
        id: 6,
        question: "Can I take the car to a mechanic to get it checked out before I buy it?",
        answer:
          "Yes, absolutely! We highly recommend all of our customers have a mechanic check out any car before purchasing it.",
    },
    {
        id: 7,
        question: "Do you charge additional fees on top of the listed price?",
        answer:
          "Yes, if you are a Colorado resident you will have to pay Colorado taxes depending on your county of residence.",
    },
    {
        id: 8,
        question: "Do I have to go to the DMV right after purchasing a car from you?",
        answer:
          "No, not if you are based in Colorado. We handle the registration and title-work for you. You will leave with a 30-day tag. If you are registering the car out of state, then yes, we will prepare a packet of paperwork for you that will have everything you need to take to your DMV to register the car in your home state.",
    },
    {
        id: 9,
        question: "Can I register the car out of state?",
        answer:
          "It depends on the specific car. Please contact us about the car that you are interested in purchasing.",
    }
  ],
  social: [
        {
          name: 'Facebook',
          href: 'https://www.facebook.com/ats.auto.detail',
          icon: (props) => (
            <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
              <path
                fillRule="evenodd"
                d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                clipRule="evenodd"
              />
            </svg>
          ),
        },
        {
          name: 'Instagram',
          href: 'https://www.instagram.com/ats.auto.sales',
          icon: (props) => (
            <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
              <path
                fillRule="evenodd"
                d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                clipRule="evenodd"
              />
            </svg>
          ),
        },
        /*{
          name: 'X',
          href: 'https://www.x.com/ats.auto.sales',
          icon: (props) => (
            <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
              <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z" />
            </svg>
          ),
        },
        {
          name: 'YouTube',
          href: 'https://www.youtube.com/ats.auto.sales',
          icon: (props) => (
            <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
              <path
                fillRule="evenodd"
                d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
                clipRule="evenodd"
              />
            </svg>
          ),
        },*/
      ],
      stock_img: [
        { id: 1,
          url: "https://ats.limestripes.com/wp-content/uploads/2025/03/stock_1.webp",
          alt: "people laughing in vehicle"
        },
        { id: 2,
          url: "https://ats.limestripes.com/wp-content/uploads/2025/03/stock_2.webp",
          alt: "used vehicle lot and sales interaction"
        },
        { id: 3,
          url: "https://ats.limestripes.com/wp-content/uploads/2025/03/stock_3.webp",
          alt: "front grille of new truck"
        },
        { id: 4,
          url: "https://ats.limestripes.com/wp-content/uploads/2025/03/stock_4.webp",
          alt: "sample vehicle in open space"
        }

      ],
      pricing : {
        frequencies: [
          { value: 'sm', label: 'Small Vehicle', priceSuffix: '/Vehicle' },
          { value: 'lg', label: 'Large Vehicle - SUV or Truck', priceSuffix: '/Vehicle' },
        ],
        tiers: [
          {
            name: 'Basic Interior',
            id: 'basic-interior',
            href: '#',
            price: { sm: '$120', lg: '$140' },
            description: 'The essentials to provide your best work for clients.',
            features: ['Thorough Vacuuming', 'Car Mat Cleaning', 'Surface Sanitization', 'Door & Dashboard Detailing', 'Window Cleaning'],
            mostPopular: false,
          },
          {
            name: 'Premium Interior Refresh',
            id: 'premium-interior',
            href: '#',
            price: { sm: '$160', lg: '$180' },
            description: 'Restore your vehicle\'s interior to like-new condition.',
            features: ['Basic Interior +', 'Stain Removal', 'Pet Hair Removal (when applicable)', 'Odor Elimination', 'Seat Shampoo & Conditioning', 'Leather Treatment (when applicable)', 'Surface Deep Clean'],
            mostPopular: false,
          },
          {
            name: 'Premium Exterior Wash',
            id: 'premium-exterior',
            href: '#',
            price: { sm: '$120', lg: '$140' },
            description: 'Preferred exterior wash and hand waxing for your vehicle.',
            features: [
              'Detailed Exterior Hand Wash',
              'Foam Cannon',
              'Wheel Cleaning',
              'High-Quality Hand Wax',
              'Tire Shine',
            ],
            mostPopular: true,
          },
          /*{
            name: 'Ultimate Detailing Session',
            id: 'ultimate-detailing',
            href: '#',
            price: { sm: '$600', lg: 'Contact Us' },
            description: 'Dedicated support and infrastructure for your company.',
            features: [
              'Premium Exterior Wash +',
              'Premium Interior Refresh +',
              'Clay Bar Treatment',
              'Advanced 2 Stage Paint Correction',
              'Showroom Quality Finish',
              'Full Day Session dedicated to your vehicle',
            ],
            mostPopular: false,
          },*/
        ],
      },
      feature_cards: [
        {
          name: 'card 1',
          imageUrl: 'https://ats.limestripes.com/wp-content/uploads/2025/03/sv1-243x300.jpg',
          imageAlt: 'Jeep Gladiator in Mountains'
        },
        {
          name: 'card 2',
          imageUrl: 'https://ats.limestripes.com/wp-content/uploads/2025/03/sv2-243x300.jpg',
          imageAlt: 'Jeep Wrangler in Mountains'
        },
        {
          name: 'card 3',
          imageUrl: 'https://ats.limestripes.com/wp-content/uploads/2025/03/sv3-243x300.jpg',
          imageAlt: 'Jeep Wrangler in Mountains'
        },
        {
          name: 'card 4',
          imageUrl: 'https://ats.limestripes.com/wp-content/uploads/2025/03/sv4-243x300.jpg',
          imageAlt: 'Jeep Wrangler in Mountains'
        },
        {
          name: 'card 5',
          imageUrl:
            'https://ats.limestripes.com/wp-content/uploads/2025/03/sv5-243x300.jpg',
          imageAlt: 'Jeep Wrangler in Mountains'
        },
        {
          name: 'card 6',
          imageUrl:
            'https://ats.limestripes.com/wp-content/uploads/2025/03/sv6-243x300.jpg',
          imageAlt: 'Jeep Wrangler in Mountains'
        }
      ]
};

export default ats;